import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";
import { getKey } from "./userMonitorEventReducer";
import { MonitorEventListFilters } from "../../service/ApiMonitorEvent";

export const listForUser = (
  state: RootState,
  org: OrganizationKeyName,
  filters: MonitorEventListFilters
) => {
  const key = getKey(org, filters);
  const data = state.userMonitorEvent.org[key];

  if (!data) {
    return [];
  }

  return data.monitorEvents;
};

export const hasMoreForUser = (
  state: RootState,
  org: OrganizationKeyName,
  filters: MonitorEventListFilters
): boolean => {
  const key = getKey(org, filters);
  const data = state.userMonitorEvent.org[key];

  if (!data) {
    return false;
  }

  return !!data.hasMore;
};

export const isLoading = (
  state: RootState,
  org: OrganizationKeyName,
  filters: MonitorEventListFilters
): boolean => {
  const key = getKey(org, filters);
  const data = state.userMonitorEvent.org[key];

  if (!data) {
    return false;
  }

  return !!data.isLoading;
};

export const nextPageUrl = (
  state: RootState,
  org: OrganizationKeyName,
  filters: MonitorEventListFilters
): string | undefined => {
  const key = getKey(org, filters);
  const data = state.userMonitorEvent.org[key];

  if (!data) {
    return undefined;
  }

  return data.nextPageUrl;
};
